import type { OptionPoints } from '@gcv/shared';

/** Options are authored as one `;`-separated string. */
export const parseFieldOptions = (options?: string): string[] =>
  (options ?? '')
    .split(';')
    .map((option) => option.trim())
    .filter((option) => option.length > 0);

/**
 * Points for the options that still exist. Keyed by label, so renaming an option drops its points.
 * Values are rounded to whole points of 0 or more, which is all the API accepts.
 */
export const syncOptionPoints = (options?: string, points?: OptionPoints): OptionPoints => {
  const synced: OptionPoints = {};

  parseFieldOptions(options).forEach((option) => {
    const existing = points?.[option];
    const isUsable = typeof existing === 'number' && Number.isFinite(existing);
    synced[option] = isUsable ? Math.max(0, Math.round(existing)) : 0;
  });

  return synced;
};
